import { useState, type ReactNode } from 'react';
import { cn } from './cn';

export type AccordionItem = { id: string; title: string; content: ReactNode };

export default function Accordion({ items, className, defaultOpen }: { items: AccordionItem[]; className?: string; defaultOpen?: string }) {
  const [open, setOpen] = useState<string | null>(defaultOpen ?? null);
  return (
    <div className={cn('divide-y divide-line border-y border-line', className)}>
      {items.map((it) => {
        const isOpen = open === it.id;
        return (
          <div key={it.id}>
            <button
              aria-expanded={isOpen}
              onClick={() => setOpen(isOpen ? null : it.id)}
              className="flex w-full items-center justify-between gap-6 py-5 text-left font-display text-xl font-semibold"
            >
              {it.title}
              <svg viewBox="0 0 12 12" className={cn('h-3 w-3 shrink-0 text-brand-dark transition-transform duration-300', isOpen && 'rotate-45')} stroke="currentColor" strokeWidth="2">
                <path d="M6 0v12M0 6h12" />
              </svg>
            </button>
            <div className={cn('grid transition-[grid-template-rows] duration-300 ease-out', isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]')}>
              <div className="overflow-hidden"><div className="pb-6 text-[1rem] leading-relaxed text-ink">{it.content}</div></div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
